<template>
    <div class="image-segment">
        <image-display :image="hasImage ? segmentData.content : defaultImage" :controls="segmentData.controls" />
        <p class="image-segment__caption" v-if="segmentData.caption">{{ segmentData.extra }}</p>
    </div>
</template>

<script>
import ImageDisplay from "~/components/handbook/ImageDisplay";

export default {
    components: { ImageDisplay },

    props: {
        id: String,
        captionId: String,
        segmentData: Object,
        imageProp: "",
    },

    data: function () {
        return {
            type: "image",
            name: "Image",
            defaultImage: "https://assets.procreate.art/community/default/default-cover.jpg",
        };
    },

    computed: {
        hasImage: function () {
            return this.segmentData.content;
        },
    },
};
</script>
